export default __webpack_public_path__ + "static/media/017-cave.23b88f18.svg";